<template>
    <div >
        <div>
            <div :class="['dimmer border-top', loading || form.loading ? 'active' : '']" >
                <div class="loader"></div>
                <div class="dimmer-content">
                    <div class="card"  >
                        <div class="card-content px-0">
                            <div class="modal-header d-flex align-items-center">
                                <h5 class="modal-title font-weight-400 mb-0">Edit User</h5>
                                <button v-if="!form.status" @click="confirmAction('activate')" class="btn btn-primary shadow-none btn-sm">Activate</button>
                                <button v-else @click="confirmAction('deactivate')" class="btn btn-primary shadow-none btn-sm">De-Activate</button>
                            </div>
                            <div class="p-4">
                                <form @submit.prevent="saveUser">
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>First Name</label>
                                                <input type="text" v-model="form.first_name" :class="['form-control', form.errors.get('first_name') ? 'is-invalid' : '']" placeholder="Enter first name">
                                                <div v-if="form.errors.get('first_name')" class="invalid-feedback">{{ form.errors.get('first_name') }}</div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Last Name</label>
                                                <input type="text" v-model="form.last_name" :class="['form-control', form.errors.get('last_name') ? 'is-invalid' : '']" placeholder="Enter last name">
                                                <div v-if="form.errors.get('last_name')" class="invalid-feedback">{{ form.errors.get('last_name') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Email</label>
                                                <input type="email" v-model="form.email" :class="['form-control', form.errors.get('email') ? 'is-invalid' : '']" placeholder="Enter email">
                                                <div v-if="form.errors.get('email')" class="invalid-feedback">{{ form.errors.get('email') }}</div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>Phone</label>
                                                <input type="text" v-model="form.phone" :class="['form-control', form.errors.get('phone') ? 'is-invalid' : '']" placeholder="Enter phone">
                                                <div v-if="form.errors.get('phone')" class="invalid-feedback">{{ form.errors.get('phone') }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 px-0">
                                        <h3 class="text-5 font-weight-400 mt-3">Permissions</h3>
                                        <div v-if="form.errors.get('permissions')" class="text-danger">{{ form.errors.get('permissions') }}</div>
                                        <hr>
                                    </div>

                                    <div class="row pb-4 text-start">
                                        <div class="col-6 ">
                                            <h3 class="text-3">User Roles</h3>
                                            <hr>
                                            <div class="role-descriptions" v-if="selectedPermissions.length">
                                                <div v-for="permission in selectedPermissions" :key="permission.id" class="mb-3">
                                                    <h5 class="text-2">{{ formatPermissionName(permission.name) }}</h5>
                                                    <small>{{ permission.description }}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div v-for="(category, key) in permissionCategories" :key="key" class="mb-2">
                                                <h5 @click="toggleCategory(key)" class="role-category d-flex justify-content-between align-items-center">
                                                    <span>{{ key }}</span>
                                                    <i :class="expandedCategories[key] ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="ml-auto"></i>
                                                </h5>
                                                <div v-if="expandedCategories[key]" class="mt-2">
                                                    <div v-for="permission in category" :key="permission.id" class="form-group px-4">
                                                        <input
                                                            type="checkbox"
                                                            :id="`perm-${permission.id}`"
                                                            v-model="form.permissions"
                                                            :value="permission.id"
                                                            class="custom-checkbox"
                                                        >
                                                        <label :for="`perm-${permission.id}`">{{ formatPermissionName(permission.name) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="submit" class="btn btn-primary btn-block mt-4">Save Changes</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
import Form from '../../../core/forms/form';


export default {
    name: "Index",
    data() {
        return {
            loading: false,
            allPermissions : [],
            form: new Form({
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                permissions: [],
                status: ''
            }),
            expandedCategories: {},
            permissionCategories: {},
            selectedPermissions: []
        };
    },

    mounted() {
        this.init();
    },

    watch: {
        'form.permissions': {
            handler(newVal) {
                this.selectedPermissions = this.allPermissions.filter(p => newVal.includes(p.id));
            },
            immediate: true,
            deep: true
        }
    },

    methods: {
        confirmAction(actionType) {
            const actionLabel = actionType === 'activate' ? 'ACTIVATE' : 'DEACTIVATE';
            const confirmationMessage = `Are you sure you want to ${actionLabel} this user?`;

            window.alerts.confirm(confirmationMessage).then((confirmed) => {
                if (confirmed) {
                    this.action(actionType);
                }
            });
        },

        action(actionType) {
            this.loading = true;
            const url = `/business/users/${this.$route.params.id}/update/${actionType}`;
            window.axios.get(url).then((response) => {
                this.form.status = response.data.body.model.status;
                this.init();
                this.loading = false;
                this.$toast.success("User Status updated successfully!", {
                    timeout: 3000
                });
            }).catch(() => {
                this.loading = false;
                this.$toast.error("Error updating user status. Please try again later.", {
                    timeout: 3000
                });
            });
        },

        init() {
            this.loading = true;
            window.axios.get(`/business/permissions`).then((permResponse) => {
                this.allPermissions = permResponse.data.body.list;
                window.axios.get(`/business/users/${this.$route.params.id}/view/list`).then((response) => {
                    const model = response.data.body.model;
                    this.form.first_name = model.name;
                    this.form.last_name = model.last_name;
                    this.form.phone = model.phone;
                    this.form.email = model.email;
                    this.form.status = model.status;
                    this.form.permissions = model.permissions.map((e) => e.id);
                    this.processPermissions();
                    this.loading = false;
                });
            });
        },

        processPermissions() {
            const grouped = {};
            this.allPermissions.forEach(permission => {
                if (!grouped[permission.category]) grouped[permission.category] = [];
                grouped[permission.category].push(permission);
            });
            this.permissionCategories = grouped;
            this.selectedPermissions = this.allPermissions.filter(p => this.form.permissions.includes(p.id));
        },

        toggleCategory(category) {
            this.$set(this.expandedCategories, category, !this.expandedCategories[category]);
        },

        formatPermissionName(name) {
            return name.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        },

        saveUser() {
            this.form.submit(`/business/users/${this.$route.params.id}/update`, this.form.data()).then((response) => {
                this.$toast.success("User updated successfully!", {
                    timeout: 3000
                });
                setTimeout(() => {
                    this.$toast.info("Reloading the page to apply new settings...", {
                        timeout: 4000
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 4000);
                }, 3000);
                const model = response.data.body.model;
                this.form.first_name = model.name;
                this.form.last_name = model.last_name;
                this.form.phone = model.phone;
                this.form.email = model.email;
                this.form.permissions = model.permissions.map((e) => e.id);
                this.processPermissions();

            });
        }
    }
};
</script>

<style>
.role-category {
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 5px;
    background-color: #f0f0f0;
    padding: 10px;
    border-radius: 5px;
}

.form-group {
    margin-bottom: 5px;
}
.role-descriptions {
    max-height: 400px;
    overflow-y: auto;
    padding: 5px;
    border-radius: 5px;
}
.custom-checkbox {
    accent-color: #252c65;
}
</style>
